/* istanbul ignore file */
import { html } from 'lit-element'
import { singleSpaLit } from '../../common'
import type { GoToNavigationLitProps } from './types'
import { GOTO_NAVIGATION_SELECTOR } from '../../common/container'

const lifecycles = singleSpaLit<GoToNavigationLitProps>({
  template: props => {
    const { links = [] } = props ?? {}
    return html`<goto-nav-rail .links=${links}> </goto-nav-rail>`
  },
  domElement: GOTO_NAVIGATION_SELECTOR,
})

export default lifecycles
